import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Box, Typography, CardHeader, Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Skeleton } from '@material-ui/lab'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import { colors } from 'common/colors'
import { AsOfToday, Delta } from './MetricBadges'

 
const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 200,
  },
  cardHeader: {
    flexShrink: 0,
    height: 64,
    boxShadow: `0px 1px 0px ${theme.palette.grey[200]}`,
  },
  cardHeaderContent: {
    flexGrow: 0,
  },
  cardAction: {
    alignSelf: 'center',
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  metric: {
    fontSize: 24,
    marginBottom: theme.spacing(1),
  },
}))

const NumericMetricCard = ({ title, tooltip, metric, metricPrevMonth, loading, error }) => {
  const styles = useStyles()
  const formattedMetric = metric ? metric.toLocaleString() : 0
  const metricChange = metric - metricPrevMonth

  return (
    <Card
      className={styles.card}
      elevation={0}
    >
      <CardHeader
        classes={{ root: styles.cardHeader, content: styles.cardHeaderContent, action: styles.cardAction }}
        title={title}
        titleTypographyProps={{ variant: 'body1', color: 'textPrimary' }}
        action={
          <Tooltip
            title={tooltip}
            aria-label={tooltip}
          >
            <Box>
              <FontAwesomeIcon
                icon={faInfoCircle}
                color={colors.primary.main}
              />
            </Box>
          </Tooltip>
        }
      />
      <CardContent className={styles.cardContent}>
        <Typography className={styles.metric}>
          {loading ? (
            <Skeleton
              className={styles.rounded}
              width={150}
            />
          ) : error ? (
            <React.Fragment>N/A</React.Fragment>
          ) : (
            formattedMetric
          )}
        </Typography>
        {loading || error ? (
          <Skeleton
            variant="rect"
            width={109}
          >
            <AsOfToday />
          </Skeleton>
        ) : metricPrevMonth === null || metricPrevMonth === undefined ? (
          <AsOfToday />
        ) : (
          <Delta delta={metricChange} />
        )}
      </CardContent>
    </Card>
  )
}

NumericMetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  metric: PropTypes.number,
  metricPrevMonth: PropTypes.number,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
}

export default NumericMetricCard
